import type { AppProps } from 'next/app';
import { useDataDogOn } from 'shared/hooks/useDataDogOn';
import { useDataDogStartView } from 'shared/hooks/useDataDogStartView';
import { useUserTracking } from '../../analytics/useUserTracking';

const SanityLayout = ({ Component, pageProps }: AppProps) => {
  useUserTracking();
  useDataDogOn();
  useDataDogStartView('core_site');

  const key = pageProps?.key;
  const myProps = { ...pageProps };
  delete myProps.key;

  return <Component key={key} {...myProps} />;
};

export default SanityLayout;
